<template>
  <!-- AAC——辅助沟通技术 -->
  <div class="AAC">
    <PublicScore :logo="Logo5" :type="'aac'" :color="'#36b9bf'" />
  </div>
</template>

<script>
import PublicScore from '../component/scoreQuery.vue'
import Logo5 from '@/assets/images/logo5.png'

export default {
  name: 'AAC',
  components: {
    PublicScore
  },
  data() {
    return {
      Logo5
    }
  }
}
</script>
